
import { Footer } from "../../components/Footer";
import Herohome from "../About/HeroHome";
import AboutComponent from "./AboutComponent";
import Detail from "./detail";
import Carousal from "./Carousal";
import Quote from "./Quote";
import Rotate from "./Rotate";
import Customer from "./Customer";
import Info from "./Info";

// About.js or About.jsx
export const Home = () => {
    return (
        <>
     
    <Herohome />
    <Customer/>
    <Info/>
 <Detail/>
 <Quote/>
 <Rotate/>
 
   <Footer/>
   
   
    </>
    
    )
    
 }  

export default Home;
